import { createFileRoute } from '@tanstack/react-router'

import { ExpenseDetailPage } from '@/pages/expenses/[id]/ExpenseDetailPage'

export const Route = createFileRoute('/_authenticated/_dashboard/expenses/$id/')({
  component: ExpenseDetailPage,
})
